import React from 'react';
import PropTypes from 'prop-types';

const Plus = ({ className }) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M18.984 12.984h-6v6h-1.969v-6h-6v-1.969h6v-6h1.969v6h6v1.969z"></path>
    </svg>
  );
};
Plus.propTypes = {
  className: PropTypes.string,
};
export default Plus;
